import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus,
    downloadDRH,
    masterEchelon,
    masterEmployeeCategories
} from "../../../../../../services/adapters/kepegawaian/homeService"

class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }
    
    fetchDownloadDRH = async (query) => {
        return await apiRequest("get", downloadDRH, {
            params: query
        }, true)
    }

    fetchEchelon = async (query) => {
        return await apiRequest("get", masterEchelon, {
            params: query
        }, true)
    }

    fetchEmployeeCategories = async (query) => {
        return await apiRequest("get", masterEmployeeCategories, {
            params: query
        }, true)
    }
}

export default IndexRepository